import { DataBean } from "../DataBean";

export class ProductInventory extends DataBean {

    public async updateProductInventory(bean: any): Promise<any> {
        return this.getCustomService(
            "ProcessContractERP",
            "com.orange.finance.processcontract.bean.ProductInventory_updateProductInventory_com.orange.finance.processcontract.bean.ProductInventory",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.orange.finance.processcontract.bean.ProductInventory"
                }
            ]
        );
    }

}